import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from './Pages/AuthPage/login';
import ChatInterface from './Pages/ChatPage/chat';
import Pricing from './Pages/PricesPage/pricing';
import Success from './Pages/SuccessPage/success';
import ChooseUs from './Pages/chooseUsPage/chooseUs';
import LandingPage from './Pages/LandingPage/landing';
import './App.css';
import Header from './components/Header/Header';
import Checkout from './Pages/CheckoutPage/checkout';
import Terms from './Pages/TermsPage/terms';
import Privacy from './Pages/PrivacyPage/privacy';
import ProtectedRoute from './components/ProtectedRoute';
import { trackPageView } from './config/googleAnalytics';

// Function to reset all body/html styles to enable scrolling
const resetScrollStyles = () => {
  // Remove all fixed positioning and height restrictions
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('height');
  document.body.style.removeProperty('width');
  document.body.style.removeProperty('position');
  document.documentElement.style.removeProperty('height');
  document.documentElement.style.removeProperty('width');
  document.documentElement.style.removeProperty('overflow');
  
  // Explicitly set scrolling properties
  document.body.style.overflow = 'auto';
  document.body.style.overflowY = 'auto';
  document.body.style.height = 'auto';
  document.body.style.position = 'relative';
  document.documentElement.style.overflow = 'auto';
  document.documentElement.style.overflowY = 'auto';
  document.documentElement.style.height = 'auto';
  
  // Remove any chat-specific classes
  document.body.classList.remove('chat-fullscreen');
  
  // Force a reflow to ensure styles are applied
  void document.body.offsetHeight;
};

// Component to track route changes and update App class
function AppContent() {
  const location = useLocation();
  const [isChatActive, setIsChatActive] = useState(false);
  
  // Reset scroll styles on initial load
  useEffect(() => {
    resetScrollStyles();
  }, []);

  // Track page views when location changes
  useEffect(() => {
    // Track page view in Google Analytics
    trackPageView(location.pathname);
  }, [location]);
  
  useEffect(() => {
    // Check if current route is the chat page
    const isChatPage = location.pathname === '/chat';
    setIsChatActive(isChatPage);
    
    // When on chat page, ensure body takes full height and disable scrolling
    if (isChatPage) {
      document.body.style.margin = '0';
      document.body.style.padding = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100vh';
      document.body.style.width = '100vw';
      document.documentElement.style.height = '100vh';
      document.documentElement.style.width = '100vw';
      document.body.classList.add('chat-fullscreen');
    } else {
      // Reset body styles when not on chat page to enable scrolling
      resetScrollStyles();
      
      // Explicitly ensure scrolling works on landing and choose-us pages
      if (location.pathname === '/' || location.pathname === '/choose-us') {
        setTimeout(resetScrollStyles, 100); // Apply again after a short delay
      }
    }
  }, [location]);

  return (
    <div className={`App ${isChatActive ? 'chat-active' : ''}`}>
      {!isChatActive && <Header />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/chat" element={
          <ProtectedRoute>
            <ChatInterface />
          </ProtectedRoute>
        } />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/success" element={
          <ProtectedRoute>
            <Success />
          </ProtectedRoute>
        } />
        <Route path="/choose-us" element={<ChooseUs />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
